<template>
    <bita-modal
        id="portfolio-form"
        :is-loading="isLoadingModal"
        :modal-lg="true"
        :title="title"
        @close="reset()"
    >
        <div slot="body">
            <bita-form ref="form">
                <div slot="body">
                    <div class="row">
                        <bita-input
                            type="text"
                            name="title"
                            label="عنوان"
                            rules="required"
                            :validation-container-class="colWidth"
                            input-class="form-control"
                            v-model="formData.title"
                        />
                        <bita-datepicker
                            type="datetime"
                            id="start_at"
                            rules=""
                            :validation-container-class="colWidth"
                            name="start_at"
                            label="تاریخ شروع پروژه"
                            inputClass="form-control"
                            v-model="formData.start_at"
                            format="YYYY-MM-DD"
                            display-format="jYYYY/jMM/jDD"
                        />
                        <bita-datepicker
                            type="datetime"
                            id="end_at"
                            rules=""
                            :validation-container-class="colWidth"
                            name="end_at"
                            label="تاریخ پایان پروژه"
                            inputClass="form-control"
                            v-model="formData.end_at"
                            format="YYYY-MM-DD"
                            display-format="jYYYY/jMM/jDD"
                        />
                        <bita-textarea
                            type="text"
                            name="description"
                            label="توضیحات"
                            validation-container-class="col-lg-12"
                            input-class="form-control"
                            v-model="formData.description"
                            rowspan="5"
                        />
                        <bita-uploader
                            name="thumbnail"
                            label="تصویر"
                            ref="uploader"
                            rules="size:50"
                            validation-container-class="col-lg-12"
                            input-class="form-control"
                            v-model="formData.thumbnail"
                            :icon-url="formData.thumbnail_url"
                        />
                    </div>
                </div>
            </bita-form>
        </div>
        <div slot="footer">
            <bita-bootbutton
                v-if="formData.id"
                title="بروز رسانی"
                type="primary mb-3"
                icon="fas fa-save"
                btn-width="150px"
                @click.native="update"
                :disabled="isLoadingModal"
            />
            <bita-bootbutton
                v-else
                title="ثبت"
                type="primary mb-3"
                icon="fas fa-save"
                btn-width="150px"
                @click.native="create"
                :disabled="isLoadingModal"
            />
        </div>
    </bita-modal>
</template>
<script>
import { portfolioApi } from "@/api/apiManagement";
export default {
    props: {
        title: String
    },
    data() {
        return {
            isLoadingModal: false,
            formData: {},
            technology: {},
            phase: {},
            colWidth: "col-lg-4",
            techColWidth: "col-lg-6"
        }
    },
    methods: {
        setInitialData(_data) {
            this.formData = _data;
        },

        create() {
            this.$refs.form.validate()
                .then( (res) => {
                    if ( res ) {
                        this.isLoadingModal = true;
                        portfolioApi.create(this.formData)
                            .then( (res) => {
                                this.$izitoast("success", "موفق!", res.data.message);
                                this.$toggleModal("#portfolio-form");
                                this.$emit("load-data");
                            })
                            .finally( () => {
                                this.isLoadingModal = false;
                            })
                    }
                })
        },
        update() {
            this.$refs.form.validate()
                .then( (res) => {
                    if ( res ) {
                        this.isLoadingModal = true;
                        let data = {
                            title: this.formData.title,
                            start_at: this.formData.start_at,
                            end_at: this.formData.end_at,
                            description: this.formData.description,
                            thumbnail: this.formData.thumbnail
                        };
                        portfolioApi.update(this.formData.id, this.$getFormData(data))
                            .then( (res) => {
                                this.$izitoast("success", "موفق!", res.data.message);
                                this.$toggleModal("#portfolio-form");
                                this.$emit("load-data");
                            })
                            .finally( () => this.isLoadingModal = false );
                    }
                })
        },
        reset() {
            this.formData = {};
            this.$refs.form.reset();
            this.$refs.uploader.reset();
        }
    }
}
</script>